var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "global-languages" },
    [
      _c(
        "a",
        {
          staticClass: "btn btn-success waves-effect waves-light text-white",
          on: {
            click: function ($event) {
              return _vm.addNewLang()
            },
          },
        },
        [
          _c("i", { staticClass: "feather icon-plus" }),
          _vm._v("\n        Add New\n    "),
        ]
      ),
      _vm._v(" "),
      _vm.loading ? _c("div", [_vm._v("Loading..")]) : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.filteredLanguages, function (language) {
        return _c("div", { staticClass: "global-language pt-05 d-flex" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: language[0],
                expression: "language[0]",
              },
            ],
            staticClass: "mr-05 form-control",
            staticStyle: { width: "300px" },
            attrs: { type: "text" },
            domProps: { value: language[0] },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(language, 0, $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: language[1],
                expression: "language[1]",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: language[1] },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(language, 1, $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pl-05 action-btns align-self-center",
              staticStyle: { width: "260px" },
            },
            [
              _c(
                "a",
                {
                  staticClass: "btn-sm btn-success text-white",
                  on: {
                    click: function ($event) {
                      return _vm.saveLanguage(language)
                    },
                  },
                },
                [_vm._v("Save")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn-sm btn-danger text-white",
                  on: {
                    click: function ($event) {
                      return _vm.removeLanguage(language)
                    },
                  },
                },
                [_vm._v("Delete")]
              ),
            ]
          ),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }